import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import { GoBackButton, ShowView, withBreadCrumbs } from "lego-gui-lib";
import { TabContent, TabData } from "../san/tabs/TabContent";
import { TabHeader } from "../san/tabs/TabHeader";
import { TitleRow } from "lego-gui-lib/lib/components/Views/TitleRow";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { ReportSubscriptionSchemaForm } from "./schema";
import {
  IndexReports,
  IndexReportsMonthly,
  ReportDetails,
  ReportDetailsMonthly
} from "./reports/views";

export const ReportSubscriptionShowView = observer(({ location }: any) => {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const title = t("hns:reportSubscription:domain");
  const baseUrl = match.url;
  const history = useHistory();

  const tabs: TabData[] = [
    {
      label: t("common:general"),
      path: "/general",
      Element: <FormView />
    },
    {
      label: t("hns:report:daily"),
      path: "/reports",
      Element: <ReportsListViewComponent />
    },
    {
      label: t("hns:report:monthly"),
      path: "/reports-monthly",
      Element: <MonthlyReportsListViewComponent />
    }
  ];

  return withBreadCrumbs(
    { to: match.url, children: title },
    <>
      <Route
        exact={true}
        path={baseUrl + "/:type"}
        render={() => {
          return (
            <>
              <TitleRow
                classes={{ titleText: "", title: "" }}
                prefix={<GoBackButton goBack={() => history.goBack()} />}
                title={title}
              />
              <TabHeader
                baseUrl={baseUrl}
                tabs={tabs}
                value={location.pathname}
              />
            </>
          );
        }}
      />

      <TabContent baseUrl={baseUrl} tabs={tabs} />
    </>
  );
});

const injectDataSource = (comp: any) =>
  inject("reportSubscription", "SAN")(observer(comp));

export const FormView = injectDataSource(({ id, reportSubscription }: any) => {
  const history = useHistory();
  return (
    <ShowView
      preloadData={false}
      dataSource={reportSubscription.oneDataSource}
      prefix={
        <GoBackButton
          goBack={() => {
            history.goBack();
          }}
        />
      }
      titleRow={false}
      fields={ReportSubscriptionSchemaForm}
      id={id}
    />
  );
});

const ReportsListViewComponent = () => {
  const match = useRouteMatch();
  const basePath = match.path;

  return (
    <>
      <Switch>
        <Route exact={true} path={basePath} component={IndexReports} />
        <Route
          exact={true}
          path={basePath + "/:id"}
          component={ReportDetails}
        />
      </Switch>
    </>
  );
};

const MonthlyReportsListViewComponent = () => {
  const match = useRouteMatch();
  const basePath = match.path;

  return (
    <>
      <Switch>
        <Route exact={true} path={basePath} component={IndexReportsMonthly} />
        <Route
          exact={true}
          path={basePath + "/:id"}
          component={ReportDetailsMonthly}
        />
      </Switch>
    </>
  );
};
